<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'

import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'

const store = useStore()
const usuario = computed(() => store.state.userSession.user.idU)
const aula = computed(() => store.state.aula)
const grupos = ref([])
const dadosCarregados = ref(false)


onMounted(() => {
    listarGrupos()
})

async function listarGrupos() {
    store.dispatch('updateLoading', true)
    const { data, erro } = await supabase
        .from('grupos_planos')
        .select('grupos!inner(id, nome, grupos_estudantes(grupo, numero_grupo, estudante, users(id, nome, img)))')
        .eq('plano', aula.value.idPlano)
        .eq('grupos.idDaAula', aula.value.idDaAula)
        .order('created_at', { ascending: false })

    if (erro) {
        alert('Ocorreu um erro ao carregar os grupos' + erro)
        store.dispatch('updateLoading', false)
        return
    }

    let array = []
    data.forEach(grupo => {
        let nomeGrupo = grupo.grupos.nome
        let estudante = grupo.grupos.grupos_estudantes.find(item => item.estudante == usuario.value)

        let numeroGrupo = estudante.numero_grupo
        let integrantesDoGrupo = []
        grupo.grupos.grupos_estudantes.forEach(item => {
            if (item.numero_grupo == numeroGrupo && item.estudante != usuario.value) {
                integrantesDoGrupo.push(item)
            }
        })
    
        array.push({ nome: nomeGrupo, numeroGrupo: numeroGrupo, integrantes: integrantesDoGrupo, estudante: estudante })

    })

    grupos.value = array
    
    dadosCarregados.value = true
    store.dispatch('updateLoading', false)


}

</script>

<template>
    <div class="pt-8 container fadein animation-duration-500 accordion-grupos-estudantes pb-8" v-if="dadosCarregados">
        <div v-if="grupos.length > 0">
            <div class="my-3 font-normal color-text text-lg  md:my-5">Meu grupo</div>
            <Accordion :activeIndex="0">
                <AccordionTab v-for="grupo in grupos" :key="grupo.grupo">
                    <template #header class="bg-white">
                        <span class="flex align-items-center gap-2 w-full ">
                            <span class="font-bold">{{ grupo.nome }}</span>
                            <div class="font-normal text-sm ml-auto ">Grupo <Badge :value="grupo.numeroGrupo" class="ml-1" /></div>
                        </span>
                    </template>
                    <p class="m-0">
                        <div v-for="integrante in grupo.integrantes" :key="integrante.estudante">
                            <div class="flex align-items-center gap-2 py-3 border-bottom-1	border-200 ">
                                
                                <div class="text-lg">{{ integrante.users.nome }}</div>
                            </div>
                        </div>
                    
                    </p>
                </AccordionTab>
            </Accordion>
        </div>
        <div v-else class="text-center text-color">
                O professor não definiu nenhum grupo para essas aulas
            </div>
    </div>
</template>
<style>
.p-accordion .p-accordion-header .p-accordion-header-link{
    background-color: #fff;
}
</style>